"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAuthenticationError = exports.sleep = void 0;
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));
exports.sleep = sleep;
const handleAuthenticationError = (error) => {
    if (error instanceof Error) {
        return error;
    }
    if (error === '1349048') {
        return new Error(`Couldn't load the url`);
    }
    if (error === '20002') {
        return new Error(`User not found`);
    }
    if (error === '20003') {
        return new Error(`User already exists!`);
    }
    return new Error('Unhandled error');
};
exports.handleAuthenticationError = handleAuthenticationError;
